import {
  OHLCCellText,
  OHLCContainer,
  OHLCTable,
  OHLCTableBodyData,
  OHLCTableFoot,
  OHLCTableFootData,
  OHLCTableHead,
  OHLCTableHeadData,
  TableOHLCTextSkeleton,
} from './TableOHLC.styled';

interface TableOHLCSkeleton {
  rows?: number;
  columns?: number;
}

const TableOHLCSkeleton = ({ rows = 10, columns = 6 }: TableOHLCSkeleton) => (
  <OHLCContainer>
    <OHLCTable>
      <OHLCTableHead>
        <tr>
          {new Array(columns).fill('').map((_, idx) => (
            <OHLCTableHeadData key={idx.toString()}>
              <TableOHLCTextSkeleton active />
            </OHLCTableHeadData>
          ))}
        </tr>
      </OHLCTableHead>
      <tbody style={{ padding: '11px 0' }}>
        {new Array(rows).fill('').map((_, idx) => (
          <tr key={idx.toString()}>
            {new Array(6).fill('').map((__, subIdx) => (
              <OHLCTableBodyData key={subIdx.toString()}>
                <OHLCCellText>
                  <TableOHLCTextSkeleton active />
                </OHLCCellText>
              </OHLCTableBodyData>
            ))}
          </tr>
        ))}
      </tbody>
      <OHLCTableFoot>
        <tr>
          {new Array(columns).fill('').map((_, idx) => (
            <OHLCTableFootData key={idx.toString()}>
              <TableOHLCTextSkeleton active />
            </OHLCTableFootData>
          ))}
        </tr>
      </OHLCTableFoot>
    </OHLCTable>
  </OHLCContainer>
);

export default TableOHLCSkeleton;
